import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F933 {
  f933_01: string;        // 薪資發放代號 (PK, max 10 chars)
  f933_11: string;        // 發放名稱 (max 20 chars)
  f933_12: string | null; // 發放日期
  f933_13: string;        // 備註 (max 60 chars)
  f933_21: number;        // 數值欄位
  f933_22: number;        // 稅率 (NUM 5,1)
  f933_91: string;        // 建立人員代號
  f933_92: string | null; // 建立/修改日期
  f933_93: string;        // 修改人員代號
}

export interface CreateRequest {
  f933_01: string;
  f933_11: string;
  f933_12: string;
  f933_13: string;
  f933_21: number;
  f933_22: number;
}

export interface UpdateRequest {
  f933_01: string;
  f933_11: string;
  f933_12: string;
  f933_13: string;
  f933_21: number;
  f933_22: number;
}

export interface ListResponse {
  data: F933[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const bonusDefApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/bonus-def', { params });
    return res.data;
  },

  async get(code: string): Promise<F933> {
    const res = await apiClient.get(`/api/bonus-def/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F933> {
    const res = await apiClient.post('/api/bonus-def', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<F933> {
    const res = await apiClient.put(`/api/bonus-def/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/bonus-def/${encodeURIComponent(code)}`);
  },
};
